export default __webpack_public_path__ + "static/media/olu-eletu.1cee15cd.jpg";